<div class="employeeId" [ngClass]="{
                    'active': employee?.status == activeEmployeeStatus,
                    'inactive': employee?.status == inactiveEmployeeStatus,
                    'future': employee?.status == futureEmployeeStatus
                    }">{{ 'EMPLOYEE_PREVIEW.employee_id' | translate }}:
  <span>{{ employee | gpEmployeeId}}</span>
</div>
